import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=79992346&scoped=true"
import script from "./MiPerfil.vue?vue&type=script&lang=js"
export * from "./MiPerfil.vue?vue&type=script&lang=js"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=79992346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79992346",
  null
  
)

export default component.exports